import { useEffect, useState } from "react";
import { useListManager } from "../../../contexts/list.manager";
import { useLocation, useNavigate } from "react-router-dom";
import SearchContainer from "../../../components/SearchContainer/SearchContainer";
import { TbCategory, TbRosetteDiscount } from "react-icons/tb";
import SearchInput from "../../../components/SearchInput/SearchInput";
import ConsultaFormContainer from "../../../components/ConsultaFormContainer/ConsultaFormContainer";
import Container from "../../../components/Container/Container";
import { BsToggles, BsToggles2 } from "react-icons/bs";
import { MdOutlineCategory } from "react-icons/md";
import ListLicenseTypes from "./ListLicenseTypes";
import { FormLicenseType } from "./FormLicenseType";

export function LicenseTypes({ ...props }) {
   const { lineSelected } = useListManager();
   const [searchText, setSearchText] = useState("");
   const [filters, setFilters] = useState("");
   const navigate = useNavigate();
   const location = useLocation();
   const [refreshKey, setRefreshKey] = useState(0);

   useEffect(() => {
      if (location.state?.deletedId) {
         setRefreshKey((k) => k + 1);
         navigate(location.pathname, { replace: true, state: {} });
      }
   }, [location.state, navigate, location.pathname]);

   return (
      <div className="consulta-container">
         <div className="search-list-wrapper">
            <SearchContainer
               icon={<MdOutlineCategory size={20} />}
               title="Tipos de licença"
               navigate={"/licenses/types/new"}
               description="Buscar"
               buttonLabel="Adicionar Tipo"
            >
               <SearchInput
                  value={searchText}
                  placeholder="Buscar"
                  onChange={({ target }) => setSearchText(target.value)}
                  onKeyPress={(e) => e.key === "Enter" && setFilters(searchText)}
               />
            </SearchContainer>
            <Container>
               <ListLicenseTypes filters={filters} refreshKey={refreshKey} />
            </Container>
         </div>
         <ConsultaFormContainer>
            <FormLicenseType licenseType={lineSelected} type="consulta" />
         </ConsultaFormContainer>
      </div>
   );
}